export default function DGParser(){

    //[1-13]Spades A-K, [14-26]Hearts A-K, [27-39]Clubs A-K, [40-52]Diamonds A-K

    this.cards = {
        "1" : ['sa.png', 1],
        "2" : ['s2.png', 2],
        "3" : ['s3.png', 3],
        "4" : ['s4.png', 4],
        "5" : ['s5.png', 5],
        "6" : ['s6.png', 6],
        "7" : ['s7.png', 7],
        "8" : ['s8.png', 8],
        "9" : ['s9.png', 9],
        "10" :['s10.png', 10],
        "11" :['sj.png', 10],
        "12" : ['sq.png', 10],
        "13" : ['sk.png', 10],

        "40" : ['da.png', 1],
        "41" : ['d2.png', 2],
        "42" : ['d3.png', 3],
        "43" : ['d4.png', 4],
        "44" : ['d5.png', 5],
        "45" : ['d6.png', 6],
        "46" : ['d7.png', 7],
        "47" : ['d8.png', 8],
        "48" : ['d9.png', 9],
        "49" : ['d10.png', 10],
        "50" : ['dj.png', 10],
        "51" : ['dq.png', 10],
        "52" : ['dk.png', 10],

        "27" : ['ca.png', 1],
        "28" : ['c2.png', 2],
        "29" : ['c3.png', 3],
        "30" : ['c4.png', 4],
        "31" : ['c5.png', 5],
        "32" : ['c6.png', 6],
        "33" : ['c7.png', 7],
        "34" : ['c8.png', 8],
        "35" : ['c9.png', 9],
        "36" : ['c10.png', 10],
        "37" : ['cj.png', 10],
        "38" : ['cq.png', 10],
        "39" : ['ck.png', 10],

        "14" : ['ha.png', 1],
        "15" : ['h2.png', 2],
        "16" : ['h3.png', 3],
        "17" : ['h4.png', 4],
        "18" : ['h5.png', 5],
        "19" : ['h6.png', 6],
        "20" : ['h7.png', 7],
        "21" : ['h8.png', 8],
        "22" : ['h9.png', 9],
        "23" : ['h10.png', 10],
        "24" : ['hj.png', 10],
        "25" : ['hq.png', 10],
        "26" : ['hk.png', 10]
    }
}

DGParser.prototype.set = function(data) {
    if (! data) return {code: -1, msg: 'detail 데이터가 존재하지 않습니다.'}

    return this.setData(data)
}

DGParser.prototype.setData = function(detailData) {
    /*
{
  "id": 10432071289,
  "tableId": 10107,
  "shoeId": 23,
  "playId": 5,
  "lobbyId": 1,
  "gameType": 1,
  "gameId": 1,
  "memberId": 71574089,
  "parentId": 16556,
  "betTime": "2022-03-07 16:38:59",
  "calTime": "2022-03-07 16:39:08",
  "winOrLoss": 0,
  "balanceBefore": 1401000,
  "betPoints": 200000,
  "betPointsz": 0,
  "availableBet": 200000,
  "userName": "PXG_4758",
  "result": "{\"result\":\"1,1,9\",\"poker\":{\"banker\":\"44-30-0\",\"player\":\"20-43-0\"}}",
  "betDetail": "{\"player\":200000.0}",
  "ip": "121.188.113.242",
  "ext": "220307B071118",
  "isRevocation": 1,
  "currencyId": 13,
  "deviceType": 1,
  "serial": "-10432071289",
  "roadid": 0,
  "pluginid": 0
 }
     */

    let status = ''
    if (detailData.isRevocation === 0) status = '미완료'
    else if (detailData.isRevocation === 1) status = '완료'
    else if (detailData.isRevocation === 2) status = '취소'
    detailData.status = status


    let userBets = []
    let detailBets = {}

    try {
      detailBets = JSON.parse(detailData.betDetail || '{}')
    } catch (e) {
      detailBets = {}
    }

    for(let key in detailBets) {
        let betAmount = detailBets[key]
        if (key.indexOf('W') > -1) continue
        let winAmount = 0

        if (Object.prototype.hasOwnProperty.call(detailBets, key + 'W')) {
          if (detailBets[key + 'W']) winAmount = detailBets[key + 'W']
        }

        userBets.push({
            target: key,
            bet: betAmount,
            win: winAmount,
            placedOn: detailData.betTime,
            id: detailData.id
        })
    }

    let detail = null
    // 결과
    if (!Object.prototype.hasOwnProperty.call(detailData, 'result')) {
    return { code: -1, msg: 'detail.data.result가 존재하지 않습니다.' }
    }

    let result = typeof detailData.result === 'string'
      ? JSON.parse(detailData.result)
      : detailData.result;

    let a = result.result.split(',')
    let b = result.result // 결과

    if (detailData.gameId === 1 || detailData.gameId === 8 || detailData.gameId === 2) {
        // 결과
        if (a[0] == 1) b = 'Banker'
        else if (a[0] == 2) b = 'Banker, Banker Pair'
        else if (a[0] == 3) b = 'Banker, Player Pair'
        else if (a[0] == 4) b = 'Banker, Banker and Player Pair'
        else if (a[0] == 5) b = 'Player'
        else if (a[0] == 6) b = 'Player, Banker Pair'
        else if (a[0] == 7) b = 'Player, Player Pair'
        else if (a[0] == 8) b = 'Player, Banker and Player Pair'
        else if (a[0] == 9) b = 'Tie'
        else if (a[0] == 10) b = 'Tie, Banker Pair'
        else if (a[0] == 11) b = 'Tie, Player Pair'
        else if (a[0] == 12) b = 'Tie, Banker and Player Pair'

        // 카드
        // "result": "{\"result\":\"1,1,9\",\"poker\":{\"banker\":\"44-30-0\",\"player\":\"20-43-0\"}}",
        let c = result.poker.banker.split('-')

        let bankerCards = []
        let bankerScore = 0
        for(let key in c) {
            let d = c[key]
            if (d == 0) continue
            let card = this.cards[d]
            if (key == 2) {
                bankerCards.push('https://static.kgonapi.com/public/images/cards_new/l_' + card[0])
            } else {
                bankerCards.push('https://static.kgonapi.com/public/images/cards_new/' + card[0])
            }

            bankerScore += card[1]
        }

        if (bankerScore > 10) {
            bankerScore = bankerScore % 10
        }

        let d = result.poker.player.split('-')
        let playerCards = []
        let playerScore = 0
        for(let key in d) {
            let e = d[key]
            if (e == 0) continue
            let card = this.cards[e]

            if (key == 2) {
                playerCards.push('https://static.kgonapi.com/public/images/cards_new/l_' + card[0])
            } else {
                playerCards.push('https://static.kgonapi.com/public/images/cards_new/' + card[0])
            }
            playerScore += card[1]
        }

        if (playerScore > 10) {
            playerScore = playerScore % 10
        }

        detail = {
            banker: {
                cards: bankerCards,
                score: bankerScore
            },
            player: {
                cards: playerCards,
                score: playerScore
            }
        }

    } else if (detailData.gameId === 3) {
        if (a[0] == 1) b = 'Dragon'
        else if (a[0] == 2) b = 'Tiger'
        else if (a[0] == 3) b = 'Tie'

        // 카드
        let c = result.poker.dragon
        let card = this.cards[c]
        const dragonCard = 'https://static.kgonapi.com/public/images/cards_new/' + card[0]
        let dragonScore = card[1]
        if (dragonScore === 11) dragonScore = 'J'
        if (dragonScore === 12) dragonScore = 'Q'
        if (dragonScore === 13) dragonScore = 'K'

        let d = result.poker.tiger
        card = this.cards[d]
        const tigerCard = 'https://static.kgonapi.com/public/images/cards_new/' + card[0]
        let tigerScore = card[1]
        if (tigerScore === 11) tigerScore = 'J'
        if (tigerScore === 12) tigerScore = 'Q'
        if (tigerScore === 13) tigerScore = 'K'

        detail = {
            dragon: {
                card: dragonCard,
                score: dragonScore
            },
            tiger: {
                card: tigerCard,
                score: tigerScore
            },
        }
    }

    return {
        code: 0,
        bets: userBets,
        detail,
        result: b
    }
}
